import counterUp from 'counterup2'

document.addEventListener("turbolinks:load", () => {
  Array.prototype.slice.call(document.getElementsByClassName("counter")).forEach(function (el) {
    counterUp(el, { duration: 5000, delay: 20, });
  });
});
